var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindowsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.53025 17.5058C4.95825 17.5058 6.14825 16.6938 6.65225 15.4898H5.36425C4.98625 16.1198 4.32825 16.5118 3.54425 16.5118C2.29825 16.5118 1.30425 15.5458 1.30425 14.1598C1.30425 12.7738 2.29825 11.8218 3.53025 11.8218C4.31425 11.8218 4.97225 12.1718 5.35025 12.7738H6.62425C6.12025 11.5978 4.94425 10.8138 3.54425 10.8138C1.65425 10.8138 0.15625 12.2558 0.15625 14.1598C0.15625 16.0498 1.64025 17.5058 3.53025 17.5058Z",
    fill: "#5A5F70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17202 17.3378H9.30602V11.9198H11.266V10.9818H9.30602V7.25781H8.17202V10.9818H6.84202V11.9198H8.17202V17.3378Z",
    fill: "#5A5F70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3917 17.3378H13.5257V13.9498C13.5257 12.7038 14.2257 11.9338 15.3037 11.9338C15.5837 11.9338 15.7657 11.9618 15.9617 12.0178V10.8558C15.8077 10.8278 15.6257 10.8138 15.4437 10.8138C14.5337 10.8138 13.8337 11.3598 13.5257 11.9478V10.9818H12.3917V17.3378Z",
    fill: "#5A5F70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2862 17.3378H18.4202V7.25781H17.2862V17.3378Z",
    fill: "#5A5F70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8679 17.3378H25.7199V14.5418H28.4199V13.7138H25.7199V10.9538H24.8679V13.7138H22.1559V14.5418H24.8679V17.3378Z",
    fill: "#5A5F70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2006 17.3378H33.3906V12.8158L37.9266 17.3378H39.5086L34.5386 12.3678L39.3686 7.81781H37.9266L33.3906 12.0878V7.81781H32.2006V17.3378Z",
    fill: "#5A5F70"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsIcon);
export default __webpack_public_path__ + "static/media/windowsIcon.6bf3e1c2685ae4abec19600c649983bd.svg";
export { ForwardRef as ReactComponent };